import { create } from 'zustand';

export const useUsersCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openUsersCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null};
  }),
}));
export const openUsersCreate = (payload) => {
  const store = useUsersCreateStore.getState();
  store.openUsersCreate(payload);
};

export const closeUsersCreate = () => {
  const store = useUsersCreateStore.getState();
  store.close();
};